import styled from 'styled-components';

export const Container = styled.div`
  display: grid;
  grid-template-columns: repeat(2, auto);
  gap: 1.6rem;
  padding: 0 4rem 1.6rem;
  margin-top: -2rem;

  @media (max-width: 600px) {
    padding: 0 0.8rem 1.6rem;
    grid-template-columns: 1fr;
  }
`;

export const Card = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;

  background-color: #fff;
  border-radius: 0.8rem;
  box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.1);
  padding: 2.4rem;
`;

export const CardImage = styled.img`
  width: 75%;
  align-self: center;
`;

export const CardTitle = styled.h3`
  color: #222;
`;

export const CardText = styled.p`
  margin-top: 0.8rem;
  text-align: justify;
`;
